import styled from 'styled-components';

export const GreenCheck = styled.div`
  width: 24px;
  height: 24px;
  background: url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%3E%3Cpath%20d%3D%22M12%2022c5.523%200%2010-4.477%2010-10S17.523%202%2012%202%202%206.477%202%2012s4.477%2010%2010%2010%22%20fill%3D%22%2300A410%22%2F%3E%3Cpath%20d%3D%22m7.5%2012%203%203%206-6%22%20stroke%3D%22%23FFF8EB%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E');
  border-radius: 50%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  flex: none;
`;

export const PositiveIcon = styled.div`
  width: 24px;
  height: 24px;
  background: url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2225%22%20height%3D%2224%22%20viewBox%3D%220%200%2025%2024%22%20fill%3D%22none%22%3E%3Cpath%20d%3D%22m20.5%206-11%2011-5-5%22%20stroke%3D%22%2300A410%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E');
  border-radius: 50%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  flex: none;
`;

export const NegativeIcon = styled.div`
  width: 24px;
  height: 24px;
  background: url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%3E%3Cpath%20d%3D%22M17%207%207%2017M7%207l10%2010%22%20stroke%3D%22%23450A0A%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E');
  border-radius: 50%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  flex: none;
`;

export const LinkedInIcon = styled.div`
  width: 24px;
  height: 24px;
  background: url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%3E%3Cpath%20fill%3D%22%23fff%22%20d%3D%22M3.844%205.684h15.149v14.307H3.844z%22%2F%3E%3Cpath%20d%3D%22M17.485%2018.342h-2.52v-3.906c0-.931-.016-2.13-1.31-2.13-1.311%200-1.512%201.015-1.512%202.062v3.974H9.624V10.31h2.419v1.098h.033a2.66%202.66%200%200%201%202.386-1.298c2.553%200%203.024%201.663%203.024%203.826zM6.782%209.212c-.289%200-.572-.085-.812-.244a1.434%201.434%200%200%201-.222-2.227%201.47%201.47%200%200%201%201.593-.314c.267.11.496.295.656.533a1.437%201.437%200%200%201-.655%202.142c-.178.072-.368.11-.56.11m1.26%209.13H5.52V10.31h2.522zM18.74%204.002H4.254a1.25%201.25%200%200%200-.88.349c-.236.227-.37.538-.374.863v14.403c.004.326.138.637.373.865.236.227.552.353.881.35h14.487c.33.004.647-.122.883-.35s.371-.538.376-.865V5.213a1.23%201.23%200%200%200-.376-.864A1.25%201.25%200%200%200%2018.74%204%22%20fill%3D%22%230A66C2%22%2F%3E%3C%2Fsvg%3E');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  flex: none;
`;

export const YoutubeIcon = styled.div`
  background: url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2265%22%20height%3D%2246%22%20viewBox%3D%220%200%2065%2046%22%20fill%3D%22none%22%3E%3Cpath%20d%3D%22M63.388%207.484c-.743-2.792-2.373-5.155-5.165-5.899C53.163.232%2032.4.108%2032.4.108S11.635.232%206.575%201.585C3.783%202.33%202.163%204.692%201.41%207.484.057%2012.544%200%2022.978%200%2022.978s.057%2010.435%201.41%2015.495c.744%202.792%202.373%205.155%205.165%205.898%205.06%201.353%2025.824%201.477%2025.824%201.477s20.764-.123%2025.824-1.477c2.792-.743%204.422-3.106%205.165-5.898%201.353-5.06%201.41-15.495%201.41-15.495s-.057-10.434-1.41-15.494%22%20fill%3D%22%23D80909%22%2F%3E%3Cpath%20d%3D%22M42.887%2022.978%2025.734%2013.45v19.059%22%20fill%3D%22%23fff%22%2F%3E%3C%2Fsvg%3E');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  flex: none;
`;
